import { useUnsafeEffect } from '@factorialco/deprecated-design-system'

import MultipleChoice from 'modules/core/components/Filter/filters/MultipleChoice'
import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import i18n from 'modules/core/lib/i18n'

interface SelectorProps {
  defaultLegalEntities?: number[]
  selectedLegalEntities?: number[] | null
  onSelectLegalEntities: (selected?: number[]) => void
}

export const LegalEntityMultiSelector = ({
  defaultLegalEntities,
  selectedLegalEntities,
  onSelectLegalEntities,
}: SelectorProps) => {
  const {
    company: { legalEntities },
  } = useCurrentSession()

  const handleOnChange = (value?: number[]) => {
    onSelectLegalEntities(
      value
        ?.map((v) => legalEntities.find((le) => le.id === Number(v))?.id)
        .filter((i) => i !== undefined)
    )
  }

  const options = legalEntities.map((legalEntity) => ({
    value: legalEntity.id,
    label: legalEntity.legalName || '',
  }))

  const value = selectedLegalEntities?.filter(
    (i) => i !== undefined && options.find((option) => option.value === i)?.value
  )

  // set default value as current value if there is no current value
  useUnsafeEffect(() => {
    if (defaultLegalEntities?.length && !selectedLegalEntities?.length && options?.length) {
      onSelectLegalEntities(
        defaultLegalEntities.filter((id) => options.find((option) => option.value === id))
      )
    }
  }, [options, onSelectLegalEntities, defaultLegalEntities, selectedLegalEntities])

  return (
    <MultipleChoice
      value={value}
      options={options}
      onValueChange={handleOnChange}
      composeActiveLabel={(selected) => `(${selected.length})`}
      label={i18n.t('finance.invoices.detail.fields.legal_entity')}
    />
  )
}
